// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import GlobalStyles from '../../config/styles';

const styles = ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center'
  },
  styleInput: {
    padding: '10px',
    borderWidth: 0.5,
    borderRadius: '5px 0 0 5px',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_GREY,
    backgroundColor: '#F4F8FA',
    textTransform: 'uppercase',

    '&:focus': {
      background: GlobalStyles.color.COLOR_PRIMARY,
    },

    '&::placeholder': {
      textTransform: 'none',
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
      color: GlobalStyles.color.COLOR_LIGHT_GRAY,
    }
  },
  styleButton: {
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 15px',
    border: 'none',
    borderRadius: '0 10px 10px 0',
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
    '&:hover': {
      opacity: 0.8
    }
  },
  textButton: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  }
});

export default styles;
